import * as React from "react"
import type { SVGProps } from "react"
const SvgFlowchart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M17 15v-2H7v2h2l.2.01A2 2 0 0 1 11 17v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3l.01-.2A2 2 0 0 1 2.8 15H5v-2c0-1.1.9-2 2-2h4V9H8a2 2 0 0 1-2-2V4l.01-.2A2 2 0 0 1 8 2h8l.2.01A2 2 0 0 1 18 4v3a2 2 0 0 1-1.8 1.99L16 9h-3v2h4a2 2 0 0 1 2 2v2h2l.2.01A2 2 0 0 1 23 17v3a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2v-3l.01-.2A2 2 0 0 1 14.8 15h.2zM3 20h6v-3H3zm12 0h6v-3h-6zM8 7h8V4H8z"
    />
  </svg>
)
export default SvgFlowchart
